import { useAtomValue } from 'jotai';
import { CalendarDays } from 'lucide-react';
import React, { Activity, useMemo } from 'react';

import { Stack } from '@crossnokaye/ux-common';

import { defrostScheduleValuesAtom } from '@/features/equipment-browser/equipment-details/state/defrost-schedule.state';
import { equipmentLoadingAtom } from '@/features/equipment-browser/equipment-details/state/equipment-response.state';
import { SectionTemplate } from '@/features/equipment-browser/equipment-details/templates/section-template';

import { AddEventButton } from './add-event-button';
import { DefrostScheduleTable } from './defrost-schedule-table/defrost-schedule-table';
import { ModeNotice } from './mode-notice';

export const EquipmentDetailsDefrostSchedule = (): React.ReactNode => {
  const isLoading = useAtomValue(equipmentLoadingAtom);
  const defrostScheduleValues = useAtomValue(defrostScheduleValuesAtom);

  const canScheduleDefrost = useMemo(
    () => ['Auto_Scheduled', 'Scheduled'].includes(defrostScheduleValues?.defrostMode ?? ''),
    [defrostScheduleValues?.defrostMode]
  );

  if (!defrostScheduleValues) {
    return null;
  }

  return (
    <SectionTemplate
      title={'Defrost Schedule'}
      icon={CalendarDays}
      isLoading={isLoading}
      rightButtons={<AddEventButton />}
    >
      <Stack>
        <DefrostScheduleTable events={defrostScheduleValues.defrostSchedule?.events ?? []} />
        <Activity mode={canScheduleDefrost ? 'hidden' : 'visible'}>
          <ModeNotice />
        </Activity>
      </Stack>
    </SectionTemplate>
  );
};
